<template>
  <div class="elevation-0">
    <v-card elevation="0" class="mb-0">
      <v-row>
        <v-col class="mt-1 text-justify">
          <form-credit-wallet
            v-show="getCloseSetCreditWalletEnterprise"
          ></form-credit-wallet>
          <form-confirm-credit-wallet
            v-show="getConfirmCreditWalletEnterprise"
          ></form-confirm-credit-wallet>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import FormCreditWallet from "./FormCreditWalletEnterprise";
import FormConfirmCreditWallet from "./FormConfirmCreditWalletEnterprise";
import { mapHelperEnterprise } from "../../../../store/helperEnterprise";
export default {
  name: "SetCreditWalletEnterprise",
  components: { FormConfirmCreditWallet, FormCreditWallet },
  data: () => ({}),

  methods: {
    sleep: function(m) {
      return new Promise(resolve => setTimeout(resolve, m));
    }
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
